import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Components

// Configs
import { DialogConfig } from '../../../shared/configs/dialog.config';
import { SnackBarConfig } from '../../../shared/configs/snackbar.config';

// Interfaces

// Services
import { SupplierSkuApiService } from '../../../shared/services/api/supplier/supplier-sku-api.service';

// Utils
import { trackById } from '../../../shared/util/track-by.util';
import { UiConfirmationDialogComponent } from '../../../ui/components/ui-confirmation-dialog/ui-confirmation-dialog.component';
import { ISupplierSku } from '../../interfaces/supplier-sku.interface';
import { SupplierSkuFormComponent } from '../supplier-sku-form/supplier-sku-form.component';

@Component({
  selector: 'lum-supplier-sku-table',
  templateUrl: './supplier-sku-table.component.html',
  styleUrls: ['./supplier-sku-table.component.scss'],
})
export class SupplierSkuTableComponent implements OnInit {
  @Input()
  supplierSkus :ISupplierSku[] = [];

  @Output()
  refreshSupplierSkuEvent :EventEmitter<boolean> = new EventEmitter<boolean>();

  trackById = trackById;

  private onDestroy$ = new Subject<void>();

  constructor(
    private dialog :MatDialog,
    private snackBar :MatSnackBar,
    private supplierSkuApiService :SupplierSkuApiService,
  ) {}

  ngOnInit() :void {}

  onEditSupplierSku(supplierSku :ISupplierSku) :void {
    this.dialog
      .open(SupplierSkuFormComponent, {
        data: {
          supplierSku,
        },
        width: DialogConfig.sizes.medium,
        disableClose: true,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((response) => {
        if (response) {
          this.refreshSupplierSkuEvent.emit(true);
        }
      });
  }

  onDeleteSupplierSku(supplierSku :ISupplierSku) :void {
    this.dialog
      .open(UiConfirmationDialogComponent, {
        data: {
          title: 'Confirm Delete',
          message: 'This will delete the record from the list. Continue?',
        },
        width: DialogConfig.sizes.small,
      })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result) => {
        if (result) {
          this.supplierSkuApiService
            .delete(supplierSku.id)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe({
              next: () => {
                this.snackBar.open('Selected record has been removed.', 'Success', {
                  duration: SnackBarConfig.DEFAULT.duration,
                });

                this.refreshSupplierSkuEvent.emit(true);
              },
              error: (err) => {
                this.snackBar.open(
                  err.message || 'Failed to delete selected record.',
                  'Error',
                  {
                    duration: SnackBarConfig.DEFAULT.duration,
                  },
                );
              },
            });
        }
      });
  }
}
